import { render, staticRenderFns } from "./PhotoCollection.vue?vue&type=template&id=57780536&"
import script from "./PhotoCollection.vue?vue&type=script&lang=js&"
export * from "./PhotoCollection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports